var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm h-100"
  }, [_c('b-card-title', {
    staticClass: "mb-2 px-6 pt-6 d-flex justify-content-between align-items-start"
  }, [_c('div', [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "box-seam",
      "variant": "primary"
    }
  }), _c('span', [_vm._v("Estoque crítico")])], 1), _c('span', {
    staticClass: "badge badge-light-primary font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.monitorados) + " monitorados ")])]), _c('b-card-body', {
    staticClass: "pl-6 pr-6 pb-4 pt-3"
  }, [_vm.loading ? [_c('b-skeleton', {
    staticClass: "mb-4",
    attrs: {
      "width": "38%",
      "height": "36px"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-5",
    attrs: {
      "width": "60%",
      "height": "14px"
    }
  }), _vm._l(3, function (i) {
    return _c('b-skeleton', {
      key: i,
      staticClass: "mb-3",
      attrs: {
        "height": "18px"
      }
    });
  })] : [_c('div', {
    staticClass: "d-flex justify-content-between align-items-end mb-5"
  }, [_c('div', [_c('h2', {
    staticClass: "display-4 text-primary mb-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.destaqueValor) + " ")]), _c('div', {
    staticClass: "text-muted font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.destaqueLabel) + " ")])]), _c('button', {
    staticClass: "btn btn-light btn-sm font-weight-bold text-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.zerados
    },
    on: {
      "click": _vm.abrirModalZerados
    }
  }, [_vm._v(" Ver zerados ")])]), _c('div', {
    staticClass: "d-flex justify-content-between mb-4"
  }, [_c('span', {
    staticClass: "text-muted font-weight-bold"
  }, [_vm._v(" Abaixo do mínimo monitorado ")]), _c('strong', {
    staticClass: "text-dark-75"
  }, [_vm._v(_vm._s(_vm.criticos))])]), _vm.listaResumo.length ? _c('ul', {
    staticClass: "list-unstyled m-0 p-0"
  }, _vm._l(_vm.listaResumo, function (item) {
    return _c('li', {
      key: item.id,
      staticClass: "d-flex justify-content-between align-items-center mb-3"
    }, [_c('span', {
      staticClass: "text-dark-75 text-truncate pr-3"
    }, [_vm._v(" " + _vm._s(item.descricao) + " ")]), _c('span', {
      staticClass: "text-muted font-weight-bold flex-shrink-0"
    }, [_vm._v(" " + _vm._s(_vm.formatNumber(item.quantidade)) + " ")])]);
  }), 0) : _c('div', {
    staticClass: "text-muted font-weight-bold"
  }, [_vm._v(" Estoque sob controle nos produtos monitorados. ")])]], 2), _c('b-modal', {
    attrs: {
      "id": _vm.modalId,
      "title": "Produtos com estoque zerado",
      "size": "lg",
      "hide-footer": ""
    }
  }, [_vm.loadingZerados ? _c('div', {
    staticClass: "py-6"
  }, _vm._l(8, function (i) {
    return _c('b-skeleton', {
      key: i,
      staticClass: "mb-3",
      attrs: {
        "height": "18px"
      }
    });
  }), 1) : _vm.modalZeradosItens.length ? _c('div', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm table-hover mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Produto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Estoque")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Mínimo")])])]), _c('tbody', _vm._l(_vm.modalZeradosItens, function (item) {
    return _c('tr', {
      key: item.id,
      staticClass: "produto-row",
      on: {
        "click": function click($event) {
          return _vm.abrirProduto(item);
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.descricao))]), _c('td', {
      staticClass: "text-right font-weight-bold"
    }, [_vm._v(" " + _vm._s(_vm.formatNumber(item.quantidade)) + " ")]), _c('td', {
      staticClass: "text-right text-muted"
    }, [_vm._v(" " + _vm._s(_vm.formatNumber(item.estoque_minimo)) + " ")])]);
  }), 0)])]), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-4 flex-wrap"
  }, [_c('span', {
    staticClass: "text-muted mb-2"
  }, [_vm._v(" Exibindo " + _vm._s(_vm.paginationFrom) + "-" + _vm._s(_vm.paginationTo) + " de " + _vm._s(_vm.zeradosTotal) + " produtos. ")]), _vm.zeradosTotal > _vm.zeradosPerPage ? _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "total-rows": _vm.zeradosTotal,
      "per-page": _vm.zeradosPerPage,
      "size": "sm"
    },
    on: {
      "change": _vm.fetchZerados
    },
    model: {
      value: _vm.zeradosPage,
      callback: function callback($$v) {
        _vm.zeradosPage = $$v;
      },
      expression: "zeradosPage"
    }
  }) : _vm._e()], 1)]) : _c('div', {
    staticClass: "text-center text-muted py-6"
  }, [_vm._v(" Nenhum produto com estoque zerado. ")])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };